// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.container {
  display: flex;
  justify-content: center; /* Center the contents horizontally */
  align-items: flex-start;
  width: 80%; /* Adjust the width to add margin on the sides */
  padding: 20px;
  margin: 0 auto; /* Center the container */
  margin-top: 40px; /* Add top margin */
}

.chessboard-container, .eval-container {
  flex: 1 1;
  margin: 10px;
}

/* Optional: Adjust these styles to better fit your design */
.chessboard-container {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  justify-content: center;
  align-items: center;
  margin-left: 50px; /* Increase left margin to move further from the edge */
}

.eval-container {
  overflow: auto;
  border: 1px solid #dee2e6;
  align-items: center;
  justify-content: center;
  height: 392px; /* Set a fixed height for the container */
}

.eval-container thead th {
  position: sticky;
  top: 0;
  background-clip: padding-box;
  z-index: 10;
}

.eval-bar {
  height: 30px;
  width: 0;
  background-color: white;
  text-align: center;
  line-height: 30px;
  color: white;
  font-weight: bold;
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,qCAAqC;EAC9D,uBAAuB;EACvB,UAAU,EAAE,gDAAgD;EAC5D,aAAa;EACb,cAAc,EAAE,yBAAyB;EACzC,gBAAgB,EAAE,mBAAmB;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,uDAAuD;AAC5E;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,yCAAyC;AAC1D;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.container {\n  display: flex;\n  justify-content: center; /* Center the contents horizontally */\n  align-items: flex-start;\n  width: 80%; /* Adjust the width to add margin on the sides */\n  padding: 20px;\n  margin: 0 auto; /* Center the container */\n  margin-top: 40px; /* Add top margin */\n}\n\n.chessboard-container, .eval-container {\n  flex: 1;\n  margin: 10px;\n}\n\n/* Optional: Adjust these styles to better fit your design */\n.chessboard-container {\n  display: flex;\n  flex-direction: column; /* Stack items vertically */\n  justify-content: center;\n  align-items: center;\n  margin-left: 50px; /* Increase left margin to move further from the edge */\n}\n\n.eval-container {\n  overflow: auto;\n  border: 1px solid #dee2e6;\n  align-items: center;\n  justify-content: center;\n  height: 392px; /* Set a fixed height for the container */\n}\n\n.eval-container thead th {\n  position: sticky;\n  top: 0;\n  background-clip: padding-box;\n  z-index: 10;\n}\n\n.eval-bar {\n  height: 30px;\n  width: 0;\n  background-color: white;\n  text-align: center;\n  line-height: 30px;\n  color: white;\n  font-weight: bold;\n  display: inline-block;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
